<template>
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_baka='lkp_baka'
    :d_lkp_ternakan='lkp_ternakan'
    :d_lkp_jurusan='lkp_jurusan'
    v-if="id > 0 && load == 3"
  /> 
  <Form 
    :d_form='form'
    :d_lkp_negeri='lkp_negeri'
    :d_lkp_baka='lkp_baka'
    :d_lkp_ternakan='lkp_ternakan'
    :d_lkp_jurusan='lkp_jurusan'
    v-else-if="id == 0 && load == 2"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.permohonan.aiman',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Permohonan', route: '/se/permohonan' },
        { label: 'Semen AI MAN', route: '/se/permohonan/aiman' },
      ],
      title : 'Tambah Semen Ai Man',
      form : {
        id : 0,
        tarikh : '',
        user_id: '',
        nama : '',
        lkp_negeri_id : '',
        hantar: 2,
        butiran: [{
          id:0,
          kuantiti: '', 
          lkp_ternakan_id: '', 
          lkp_jurusan_id:'', 
          lkp_baka_id:'', 
          catatan:'', 
          jenis:'',
          se:'',
          se_permohonan_id:'',
          kuantiti_disetujui:'',
          lkp_status_id:'',
          lkp_jurusan: [],
          lkp_baka: [],
        }]
      },
      form1:[],
      lkp_ternakan : [],
      lkp_negeri: [],
      lkp_jurusan: [],
      lkp_baka: [],
      load : 0
      
      
    }
  },
  methods: {
    
    getGetnoBatch(){
      this.$zcomm.get(this.api_service + 'se_pendaftaran/get', {}).then(res => {
        this.se_pengeluaran = res
        this.load = this.load + 1
      })
    },
 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'permohonan/aiman/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
    getNegeri(){
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
        this.lkp_negeri = res
        this.load = this.load + 1
      })
    },
    getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
        this.load = this.load + 1
      })
    },

    
  
  },

  watch: {

  },
  mounted() {
    this.getData();
    this.getNegeri();
    this.getTernakan();
  }
    
}
</script>
